//
//
//
//
//
//
//
//
//
//
//
//
//

import uniqueid from 'lodash.uniqueid'
// 组件
import d2LayoutMainMenuItem from '../menu-item'

export default {
  name: 'd2-layout-header-aside-menu-sub',
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem
  },
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      uniqueid: uniqueid('d2-menu-empty-')
    }
  }
}
